<template>
  <v-menu
    ref="dTPkr"
    v-model="menu"
    transition="fade-transition"
    min-width="280"
    :close-on-content-click="false"
    :close-on-click="false"
    offset-y
    allow-overflow
    offset-overflow
  >
    <template v-slot:activator="{ on }">
      <v-input
        :value="getDateValue"
        :class="[getIrisCssClass, getDateTimeClass]"
        :disabled="getIrisRdonlyMode"
        :filled="getIrisRdonlyMode"
        :on="on"
        :ename="$attrs.ename"
        :id="$attrs.id"
        ref="dateIn"
        class="dateTimeInput v-text-field row no-gutters pa-0 mt-4"
        @keypress.enter.native="userSave"
        @keypress.esc.native="userCancel"
        @keyup.native="menu = false"
        @keyup.backspace.native="menu = false"
        cols="5"
        :rules="rules"
        v-click-outside="closeMenu"
      >
        <label
          :class="getIrisRdonlyMode ? 'ml-3 pb-2' : ''"
          class="v-label v-label--active theme--light"
          style="position: absolute"
        >
          {{ $attrs.label }} <span v-if="$attrs.required" class="red--text">*</span></label
        >
        <v-col cols="auto">
          <v-icon
            :class="getDateTimeIconClass"
            :color="currentTab === 0 && $refs.dateIn.isFocused ? getColorIcon : ''"
            class="mr-2"
            >mdi-calendar-range</v-icon
          >
          <input
            @mouseover="closeLocked = true"
            @mouseout="closeLocked = false"
            id="dateField"
            type="text"
            v-model.lazy="formattedSavedDate"
            @focus="customFocus(true, 0)"
            :placeholder="$attrs.placeholder ? $attrs.placeholder : format"
            @blur="customFocus(false)"
            @click="openMenu()"
            autocomplete="off"
          />
          <!-- <v-icon :ripple="false" class="mr-2" v-if="savedDate != null" @click="savedDate = ''">mdi-close</v-icon> -->
        </v-col>
        <v-col cols="2">
          <v-icon
            :class="getDateTimeIconClass"
            :color="currentTab === 1 && $refs.dateIn.isFocused ? getColorIcon : ''"
            class="mr-2"
            >mdi-clock-time-four</v-icon
          >
          <input
            @mouseover="closeLocked = true"
            @mouseout="closeLocked = false"
            id="timeField"
            v-model="formattedSavedTime"
            placeholder="hh:mm"
            @focus="customFocus(true, 1)"
            @blur="customFocus(false)"
            @click="openMenu()"
          />
        </v-col>
        <v-col v-if="getIrisRdonlyMode" class="mt-4 mr-2 d-flex justify-end flex-1">
          <v-icon>mdi-lock</v-icon>
        </v-col>
      </v-input>
    </template>
    <v-card
      max-width="300"
      ref="dateTimePicard"
      @mouseover="closeLocked = true"
      @mouseout="closeLocked = false"
      @keypress.enter.native="userSave"
      @keypress.esc.native="userCancel"
    >
      <v-tabs fixed-tabs v-model="currentTab" hide-slider>
        <v-tab>
          <v-icon>mdi-calendar-range</v-icon>
        </v-tab>
        <v-tab>
          <v-icon>mdi-clock-time-four</v-icon>
        </v-tab>
        <v-tab-item>
          <edn-date :locale="getDateLocale" v-model="savedDate" :format="format" :min="min" @input="inputDate($event)"></edn-date>
        </v-tab-item>
        <v-tab-item>
          <edn-time
            no-title
            ref="timePicker"
            v-model="savedTime"
            :min="getTimeFromMin"
            @input="inputCheck($event)"
            @click:minute="menu = false"
          ></edn-time>
        </v-tab-item>
      </v-tabs>

      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn text color="primary" @click="userCancel">Annuler</v-btn> -->
        <v-btn text color="primary" @click="userSave">Ok</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<script>
import { ednRequired } from './mixins/ednRequired'
import { ednMimicMix } from './mixins/ednMimicMix'

import {
  format as fnsFormat,
  parseISO as fnsParseISO,
  isValid as fnsIsValid,
  parse as fnsParse,
  formatRelative,
  subDays,
} from 'date-fns'
import { fr, enGB, es, de, nl, it } from 'date-fns/locale'

export default {
  inheritAttrs: false,
  mixins: [ednRequired, ednMimicMix],
  props: {
    value: {
      type: String,
      default: () => null,
    },
    min: {
      type: String,
      default: () => null,
    },
    format: {
      type: String,
      default: () => 'dd-MM-yyyy',
    },
    invalidDateMsg: {
      type: String,
      default: () => 'Vous devez entrer une date et une heure valide.',
    },
    timeRequired: {
      type: Boolean,
      default: () => false,
    }
  },
  watch: {
    value(val) {
      this.$emit('input', val)

      let dateOld = this.savedDate + 'T' + this.savedTime;
      if(dateOld !== val){
        this.savedDate = fnsFormat(fnsParseISO(val), 'dd/MM/yyyy');
        this.savedTime = fnsFormat(fnsParseISO(val), 'HH:mm');
      }
    },
  },
  data() {
    return {
      menu: false, //Définit si le menu est visible ou non
      closeLocked: false,
      currentTab: null, //Définit l'onglet courant

      // savedDate: this.value != null && this.value != '' ? this.value.split('T')[0] : null, //Stocke la date
      // savedTime: this.value != null && this.value != '' ? this.value.split('T')[1].substr(0, 5) : null, //Stocke l'heure en ne gardant que l'heure et les minutes
      savedDate: null, //Stocke la date
      savedTime: null, //Stocke l'heure en ne gardant que l'heure et les minutes

      colors: {
        //Définit les couleurs de vuetify
        primary: this.$vuetify.theme.currentTheme.primary,
        secondary: this.$vuetify.theme.currentTheme.secondary,
      },
      enGB,
      fr,
      es,
      de,
      nl,
      it,
      formatRelative,
      subDays,
    }
  },
  mounted() {
    this.$vuetify.theme.currentTheme.primary
    this.rules.push((v) => (fnsIsValid(new Date(v)) || v == '') || this.invalidDateMsg) // Règle poussée pour faire un callback en cas d'erreur de format.

    this.changeSavedDates();
  },
  computed: {
    getTimeFromMin(){
      if(this.min != null && this.min != ''){
        let minDate = new Date(this.min);
        return minDate.getHours() + ':' + minDate.getMinutes();
      }
      return null;
    },
    /**
     * Permet de récupérer la valeur transmise et de vérifier si le format est correct.
     */
    getDateValue(){
      let dateTimeValue = "";
      if(this.savedDate != null)
        dateTimeValue += this.savedDate;

      if(this.savedTime != null)
        dateTimeValue += ' ' + this.savedTime

      return dateTimeValue || this.value;
    },
    getColorIcon() {
      if (this.menu) {
        return this.colors.primary
      } else {
        return ''
      }
    },
    formattedSavedDate: {
      get() {
        if (this.savedDate && this.savedTime) {
          let newDate = new Date(this.savedDate + ' ' + this.savedTime);

          if (fnsIsValid(newDate)) {
            return fnsFormat(fnsParseISO(this.savedDate), this.format, { locale:eval('this.' + this.$attrs.locale) });
          }

          return '';
        }
      },
      set(value) {
        let dateString
        if (value !== '') {
          let parsetoDate = fnsParse(value, this.format, new Date())
          let parseToSystemFormat = fnsFormat(parsetoDate, 'yyyy-MM-dd')
          this.savedDate = parseToSystemFormat
          dateString = this.savedDate + 'T' + this.savedTime
        } else {
          this.savedDate = this.savedTime = ''
          dateString = null
        }
        this.$emit('input', dateString)
      },
    },
    
    formattedSavedTime: {
      get() {
          return this.savedTime;
      },
      set(value) {
        this.savedTime = value;
        
        if (this.savedDate && this.savedTime) {
          let newDate = new Date(this.savedDate + ' ' + this.savedTime);

          if (fnsIsValid(newDate)) {
            let dateString = this.savedDate + 'T' + this.savedTime;
            this.$emit('input', dateString)
          }
        }
      },
    },
    /**
     * Renvoie la langue de la date, par défaut en fr
     */
    getDateLocale() {
      return this.$attrs.locale || 'fr'
    },
    getDateTimeClass() {
      return this.getIrisRdonlyMode ? 'v-text-field--filled edn-datetime--readonly' : ''
    },
    getDateTimeIconClass() {
      return this.getIrisRdonlyMode ? 'ml-2 mt-5' : ''
    },
  },
  methods: {
    /** Fait la transformation de la valeur pour la transmettre au bon format au composant edn-time et edn-date 
     * Si on vient de la saisie guidée ou d'un autre projet iris, on transforme la valeur 
     * récupérée pour la transformer au format demandé par les composants eudofront
    */
    changeSavedDates(){
      if (this.value != null && this.value != '' 
      && this.value.includes('T')
      && !this.$attrs['iris-mimic']) {
        this.savedDate = this.value.split('T')[0]
        this.savedTime = this.value.split('T')[1]
      } else if (this.value != null && this.value != '' 
      && !this.value.includes('T') 
      && this.$attrs['iris-mimic']) {
        this.convertFormat();
      } else if (this.value != null && this.value != '' 
      && !this.value.includes('T') 
      && !this.$attrs['iris-mimic']) {
        this.convertFormat();
        this.$emit('input',this.savedDate + 'T' + this.savedTime);
      } else {
        this.savedDate = null
        this.savedTime = null
      }
    },
    openMenu() {
      this.menu = true
    },
    customFocus(bool, tab) {
      //bool : est-ce que le focus est actif
      //tab : quel onglet est concerné

      this.$refs.dateIn.hasColor = bool
      this.$refs.dateIn.isFocused = bool

      if (tab != null || undefined) {
        this.currentTab = tab
      }
    },
    closeMenu() {
      if (!this.closeLocked) {
        this.menu = false
        if (this.$refs.timePicker) this.$refs.timePicker.resetSelect()
      }
    },
    inputCheck(e) {
      // Si on vient de la saisie guidée ou d'un autre projet iris, on renvoit la date au format demandé
      if(this.$attrs['iris-mimic']){
        let dateTimeValue = "";
        if(this.savedDate != null)
          dateTimeValue += this.savedDate;

        if(this.savedTime != null)
          dateTimeValue += 'T' + this.savedTime;
        let val = fnsFormat(fnsParseISO(dateTimeValue), "dd/MM/yyyy HH:mm:ss",{locale:eval('this.' + this.$attrs.locale)});
        this.$emit('input',val );
        return true;
      }


      if (e && e.includes(':')) this.$refs.timePicker.selectMin()
      // let fnsDate = this.savedDate + 'T' + this.savedTime
      //   fnsParseISO(fnsDate)
      if (fnsIsValid(new Date(this.savedDate + 'T' + this.savedTime))) {
        // this.$refs.timePicker.resetSelect() //Permet d'envoyer un reset au timePicker

        this.$emit('input', this.savedDate + 'T' + this.savedTime)
      } else if (this.savedDate === '' && this.savedTime === '') {
        // this.$refs.timePicker.resetSelect('clear') //Permet d'envoyer un reset au timePicker et une RàZ des datas

        this.$emit('input', '')
      }
    },
    inputDate(e) {
      this.savedDate = e
      if(e && !this.savedTime) this.savedTime = '00:00'
      // if time is not required, hide the menu
      if (this.timeRequired) {
        this.currentTab = 1
      } else {
        this.menu = false
      }
      this.inputCheck(e)
      // this.$emit('input', e + 'T' + this.savedTime)
    },
    userSave() {
      this.$refs.dTPkr.save(this.formattedSavedDate)
      setTimeout(() => {
        this.currentTab = null
        if (this.$refs.timePicker) {
          this.$refs.timePicker.resetSelect()
        }
      }, 500)
    },
    userClear() {
      this.$refs.timePicker.resetSelect('clear')
    },
    userCancel() {
      this.menu = false
      this.currentTab = 0
    },
    /** Convertit au bon format */
    convertFormat(){
        let dateSplitted = this.value.split(' ');
        let time = dateSplitted[0];
        let hour = dateSplitted[1].slice(0, 5) || '00:00';
        let timeSplitted = time.split('/');
        this.savedDate = timeSplitted[2] + '-' + timeSplitted[1] + '-' + timeSplitted[0];
        this.savedTime = hour;
    },

  },
}
</script>
<style lang="scss">
div {
	&.dateTimeInput {
		div {
			&.col {
				display: flex;
				padding: 0;
			}
		}
	}
}

.v-text-field--filled.edn-datetime--readonly .v-label{
  top:15px;
}

.edn-datetime--readonly i.v-icon.notranslate.mdi.mdi-lock.theme--light {
    color: rgb(0, 0, 0, 0.30);
}

</style>
